/**
 * 이미지 게이트웨이 싱글턴(결정 #19). 키 볼트(결정 #15)와 묶어 전역 공유한다.
 */
import { WebImageGateway } from "../platform/image/index.js";
import { keyVault } from "../platform/vault/index.js";

export const imageGateway = new WebImageGateway(keyVault);
